module.exports = __webpack_public_path__ + "img/inside-factory-2.d4e9d356.jpg";